class BopisEntity {
  constructor({ ...data }) {
    this.response = JSON.parse(data?.response) || {};
    this.success = data?.success || false;
  }
}

export default BopisEntity;
